import { Navigate } from 'react-router-dom';
import { useAuth } from '@clerk/react';

export function ProtectedRoute({ children }: { children: React.ReactNode }): JSX.Element {
  const { isSignedIn, isLoaded } = useAuth();
  if (!isLoaded) return <></>;
  if (!isSignedIn) return <Navigate to="/login" replace />;
  return <>{children}</>;
}
